import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import { type ExtendedBuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { curriculumSelectorComponent } from '@nodeTypeConfig/helpers/editComponents/curriculumSelector';
import { proThemesComponent } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { extendsSection } from '../../helpers/genericConfigHelpers';

// Extends SECTION => A SECTION inside a PRONEWSLETTER or a PRONEWSLETTERTEMPLATE becomes a PRO_NEWSLETTER_SECTION
const PRO_NEWSLETTER_SECTION: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [selectCurriculumThemesValidation],
  information: {
    single: 'Titel',
    plural: 'Titels',
    ribonIcon: require('../../../../../img/buildingBlocks/SECTION.svg'),
  },
  ...extendsSection,
  isCollapsedByDefault: false,
  buildingBlocks: [
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE },
    { type: NodeType.PRO_NEWSLETTER_CALENDAR },
    { type: NodeType.TEASER, showInAncestorTypes: [NodeType.PRONEWSLETTER] },
    { type: NodeType.WORD_IMPORT },
  ], // no SECTION in PRONEWSLETTER SECTION you can only go one level deep
  edit: [titleComponent, proThemesComponent, curriculumSelectorComponent],
};
export default PRO_NEWSLETTER_SECTION;
